<div class="font-MM fw-700 mb-m">{{ 'page.infrastructure.overview.schemaOverview' | translate }}</div>
<div #svgContainer></div>
<div *ngIf="!infrastructure" class="no-schema-container flex-column flex-center gap-L pad-XL" >
	<img src="assets/illustrations/empty-app.svg">
	<span class="grey text-center">{{ 'page.infrastructure.overview.schemaDisabled' | translate }}</span>
</div>
